

import Bus from '@/utils/bus';
import global from '@/utils/global';
import {focusNumber} from '@/utils/dom';
import store from '@/stores';
import {setFocusIndex as setFocusIndexListening, setIsSubject, setPanelDataByIndex as setPanelDataByIndexListening, setPlayInfo} from '@/stores/slice/listening';
import {setFocusIndex as setFocusIndexReading, setPanelDataByIndex as setPanelDataByIndexReading} from '@/stores/slice/reading';
import AIContant from './aiContant';
import { getListeningQuestionAnalyze } from './analyze/getListengintQuestionAnalyze';
import { getReadingQuestionInfo } from './analyze/getReadingQuestionInfo';

let audioPlayHandle: (() => void) | null; 

export type IplayAudio = (value: {start_time: number; end_time: number; number: number;}, key?: string) => void
export type IparsingAI = (value: {number: number;}) => void

export const playAudio:IplayAudio = (item, key)=> {
  Bus.publish(AIContant.AUDIO_STOP, undefined);
  let {start_time: startTime, end_time: endTime} = item;
  const audio = document.getElementById('audio') as HTMLAudioElement;
  startTime = startTime / 1000; // 开始时间（以秒为单位）
  endTime = endTime/ 1000; // 结束时间（以秒为单位）
  const playHandle = () => {
    // AI播放语音
    if (playIndex !== item.number || item.number === -2){
      store.dispatch(setPlayInfo({playIndex: item.number, playStatus: 'play'}));
      if (audio) {
        if (audioPlayHandle) {
          audio.removeEventListener('timeupdate', audioPlayHandle);
          audioPlayHandle = null;
        }
  
        audioPlayHandle = function audioPlay() {
          if (audio.currentTime >= endTime || audio.currentTime < startTime) {
            audio.pause();
            audio.removeEventListener('timeupdate', audioPlay);
            audioPlayHandle = null;
            store.dispatch(setPlayInfo({playIndex: -1, playStatus: 'pause'}));
          } 
        };
  
        audio.currentTime = startTime;
        audio.addEventListener('timeupdate', audioPlayHandle);
        audio.play().catch(err => {
          console.error('播放音频错误2', err);
          store.dispatch(setPlayInfo({playIndex: -1, playStatus: 'pause'}));
          Bus.publish(AIContant.AUDIO_STOP, undefined);
        });
      }
    } else if (playStatus === 'play' && playIndex === item.number) {
      store.dispatch(setPlayInfo({playIndex, playStatus: 'pause'}));
      if (audio) {
        audio.pause();
      }
      return;
    } else if (playStatus === 'pause' && playIndex === item.number) {
      store.dispatch(setPlayInfo({playIndex, playStatus: 'play'}));
      if (audio) {
        audio.play().catch(err => {
          console.error('播放音频错误1', err);
          store.dispatch(setPlayInfo({playIndex: -1, playStatus: 'pause'}));
          Bus.publish(AIContant.AUDIO_STOP, undefined);
        });
      }
      return;
    }
  };
  // 修改播放语音的状态
  const {playStatus, playIndex} = store.getState().listening;
  if (item.number === -2 && key) {
    const aiNumber:number = parseFloat(key.split('_')[0]);
    const pageState = store.getState().listening;
    const {limits, } = pageState;
    const fIndex = limits.findIndex((item: {min :number; max: number;}) => {
      const {min, max} = item;
      return aiNumber >= min && aiNumber <= max;
    });
    if (fIndex !== -1) {
      store.dispatch(setIsSubject(true));
      store.dispatch(setFocusIndexListening({index: aiNumber}));
      store.dispatch(setPanelDataByIndexListening({index: fIndex}));
      setTimeout(() => {
        playHandle();
      }, 20);
      return;
    }
  }

  playHandle(); 
};

export function stopAudio() {
  const audio = document.getElementById('audio') as HTMLAudioElement;
  if (audio) {
    audio.pause();
  }
}

export function clearAudioHandle() {
  const audio = document.getElementById('audio') as HTMLAudioElement;
  if (audioPlayHandle && audio) {
    audio.removeEventListener('timeupdate', audioPlayHandle);
    audioPlayHandle = null;
    store.dispatch(setPlayInfo({playIndex: -1, playStatus: 'pause'}));
  }
}

export const parsingAI:IparsingAI = (item) => {
  const {number} = item;
  // const {userPermission} = store.getState().user; 
  // let isVip = false;
  // if (global.subject === 'listen') {
  //   isVip = userPermission.listening.isVip;
  // } else if (global.subject === 'read') {
  //   isVip = userPermission.reading.isVip;
  // } else if (global.subject === 'write') {
  //   isVip = userPermission.writing.isVip;
  // }

  // if (!isVip) {
  //   Modal.confirm({
  //     title: i18n.t('common.dauyan_you_are_not_vip'),
  //     content: '',
  //     okText: i18n.t('common.dauyan_pay_now'),
  //     cancelText: i18n.t('common.dauyan_cancel'),
  //     okButtonProps: {
  //       style: { outline: 'none', background: '#4A9E81' }
  //     },
  //     cancelButtonProps: {
  //       style: { display: 'inline'}
  //     },
  //     onCancel: () => {
  //       console.log('cancel', document.getSelection());
  //     },
  //     onOk() {
  //       // const encoded = btoa(window.location.href);
  //       // window.location.href = `${payUrl}?redirectUrl=${encoded}`;
  //       // window.open(`${ieltsWeb}#/?buyVip=true`);
  //       buyVipDialog();
  //     },
  //     afterClose: () => {
  //       console.log('after close', document.getSelection());
  //     },
  //   });
  //   return;
  // }

  let info;
  if (window.location.href.indexOf('listening') > -1) {
    info = getListeningQuestionAnalyze(number);
  } else {
    info = getReadingQuestionInfo(number);
  }
  if (info) {
    Bus.publish(AIContant.AI_PANEL_ANALYZE_QUESTION, {question_number: number, reference: info.reference, answer: info.answer});
  }
};


export const focusNumberAI = (number:number) => {

  let pageState;
  if (global.subject === 'listen') {
    pageState = store.getState().listening;
  } else if (global.subject === 'read') {
    pageState = store.getState().reading;
  }
  if (pageState){
    const {limits, } = pageState;
    const fIndex = limits.findIndex((item: {min :number; max: number;}) => {
      const {min, max} = item;
      return number >= min && number <= max;
    });
    if (fIndex !== -1) {
      if (global.subject === 'listen') {
        store.dispatch(setIsSubject(true));
        store.dispatch(setFocusIndexListening({index: number}));
        store.dispatch(setPanelDataByIndexListening({index: fIndex}));
      } else if (global.subject === 'read') {
        store.dispatch(setFocusIndexReading({index: number}));
        store.dispatch(setPanelDataByIndexReading({index: fIndex}));
      }
      setTimeout(()=> {
        focusNumber(number, limits[fIndex].min);
      },20);
    }
  }
};

export const getReadingReference = (id:number) => {
  const map = store.getState().reading.referenceMap;
  return map[id] || {};
};